import { createSlice, isAnyOf } from "@reduxjs/toolkit"
import { Resume, ResumeUpload, ResumeUploadStatus } from "./interface"
import { compareResumes, retrieveResume, retrieveResumes, retrieveResumeUploads, uploadResumes } from "./ResumeAction"

interface ResumeState {
  resume: Resume
  resumeList: Resume[]
  resumeUploadList: ResumeUpload[]
  totalRecords: Number | undefined
  resumeUploading: boolean
  compareResults: any
}

const initialState = {
  resume: {} as Resume,
  resumeList: [],
  resumeUploadList: [],
  totalRecords: undefined,
  resumeUploading: false,
  compareResults: {},
} as ResumeState

const resumeSlicer = createSlice({
  name: 'resume',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
    .addCase(retrieveResumes.fulfilled, (state: any, { payload }) => {
      state.resumeList = payload.content
      state.totalRecords = Number(payload.totalElements)
    })
    .addCase(retrieveResume.pending, (state: any, { payload }) => {
      state.resume = {} as Resume
    })
    .addCase(retrieveResume.fulfilled, (state: any, { payload }) => {
      state.resume = payload
    })
    .addCase(retrieveResumeUploads.fulfilled, (state: any, { payload }) => {
      state.resumeUploadList = payload.content
      state.totalRecords = Number(payload.totalElements)

      // loop through upload list and if there are not record pending, set resumeUploading to false
      state.resumeUploading = state.resumeUploadList.some((upload: ResumeUpload) => upload.status === ResumeUploadStatus.PENDING)
    })
    .addCase(uploadResumes.fulfilled, (state: any, { payload }) => {
      state.resumeUploading = true
    })
    .addCase(compareResumes.fulfilled, (state: any, { payload }) => {
      state.compareResults = payload
    })
  },
})

export default resumeSlicer.reducer